import {CALL_API} from 'redux/middleware/api'
import {STORE_WIZARD_DATA, CLEAR_STORAGE, GET_STORAGE} from './'

function deleteStorageByKeys(keys) {
  return {
    [CALL_API]: {
      endpoint: 'user/storage',
      method: 'DELETE',
      types: CLEAR_STORAGE,
      body: {storageKey: keys}
    }
  }
}

function getStorage() {
  return {
    [CALL_API]: {
      endpoint: 'user/storage',
      method: 'GET',
      types: GET_STORAGE
    }
  }
}

export function saveWizardState(data) {
  return {
    type: STORE_WIZARD_DATA,
    storageKey: 'wizard',
    data
  }
}

export function clearStorage(keys) {
  return dispatch => {
    return dispatch(deleteStorageByKeys(keys))
      .success(() => dispatch(getStorage()))
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/wizard/actions.js